/** Модели авто, которые должны отправляться и в банки и в лизинг */
export const BANKS_LEASING_MODELS = [
  {
    cityName: 'г.Алматы',
    brands: [
      { brandCode: 6, modelNames: ['T1'] } // Jerour
    ]
  },
  {
    cityName: 'г.Астана',
    brands: [
      { brandCode: 6, modelNames: ['T1'] } // Jerour
    ]
  }
];
